import {styled} from "@mui/material/styles";
import {Grid, Typography} from "@mui/material";

export const LandingWhiteShadowHeader = styled(Typography)(({theme}) => ({
  color: '#FFFFFF',
  textShadow: '0rem 0.29rem 0.29rem rgba(0, 0, 0, 0.25)',
  fontSize: 64,
  [theme.breakpoints.down('sm')]: {
    fontSize: 32,
  },
}));

export const LandingSubheader = styled(LandingWhiteShadowHeader)(() => ({
  fontFamily: 'Satoshi-Variable',
  fontWeight: 500,
  '&&': {
    fontSize: '1.71rem',
    lineHeight: '2.29rem',
  },
}));

export const LandingGrid = styled(Grid)(() => ({
  height: '10%'
}));
